/* global debounce */

if (!customElements.get('slide-show-scheduler')) {
  class SlideShowScheduler extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      // 1. Önce zamanlaması uymayan slaytları DOM'dan temizle
      this.filterScheduledSlides();

      // 2. Elementleri seç
      this.slideshow = this.querySelector('.slideshow');
      this.slides = this.querySelectorAll('.slideshow__slide');
      
      // Eğer hiç slide kalmadıysa (hepsi filtrelendiyse), container'ı gizle ve çık
      if (this.slides.length === 0) {
        this.style.display = 'none';
        return;
      }

      this.nav = this.querySelector('.slideshow-nav');
      this.pagination = this.querySelector('.slideshow-pagination');
      this.rtl = document.dir === 'rtl';
      this.currentIndex = 0;
      this.swipeThreshold = 80;
      this.wheelSensitivity = 15;

      if (this.nav) {
        this.counterCurrent = this.querySelector('.slideshow-nav__counter-current');
        this.counterTotal = this.querySelector('.slideshow-nav__counter-total');
        
        // Counter total'i güncelle (çünkü bazı slide'lar silinmiş olabilir)
        if (this.counterTotal) {
          this.counterTotal.textContent = this.slides.length;
        }

        this.nav.addEventListener('click', this.handleNavClick.bind(this));
      }

      if (this.pagination) {
        this.pageBtns = this.querySelectorAll('.page-btn');
        this.pagination.addEventListener('click', this.handlePaginationClick.bind(this));
      }

      // İlk slide'a aktif class'ı ver (Eğer ilk slide silindiyse, yeni ilk slide aktif olmalı)
      this.slides.forEach(slide => slide.classList.remove('is-active'));
      if(this.slides.length > 0) {
        this.slides[0].classList.add('is-active');
      }

      if (theme.device.hasTouch) {
        this.slideshow.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
        this.slideshow.addEventListener('touchmove', debounce(this.handleTouchMove.bind(this), 200), { passive: true });
      }

      this.slideshow.addEventListener('wheel', this.handleWheel.bind(this), { passive: false });
      this.slideshow.addEventListener('keydown', this.handleKeyDown.bind(this));

      this.slideshow.addEventListener('transitionend', SlideShowScheduler.handleTransitionend);

      this.setSlideVisibility();
      if (this.dataset.autoplay === 'true' && this.slides.length > 1) this.initAutoPlay();
    }

    /**
     * Slide'ların zamanlamasını kontrol eder ve süresi gelenleri gösterir, gelmeyenleri siler.
     */
    filterScheduledSlides() {
      const allSlides = this.querySelectorAll('.slideshow__slide');
      const allPageBtns = this.querySelectorAll('.page-btn');
      const now = new Date();

      // Silinecek indexleri tut
      let indexesToRemove = [];

      allSlides.forEach((slide, index) => {
        const startStr = slide.dataset.scheduleStart;
        const endStr = slide.dataset.scheduleEnd;
        let shouldRemove = false;

        // Başlangıç tarihi kontrolü
        if (startStr) {
          const startDate = new Date(startStr);
          if (!isNaN(startDate) && now < startDate) {
            shouldRemove = true;
          }
        }

        // Bitiş tarihi kontrolü
        if (endStr && !shouldRemove) {
          const endDate = new Date(endStr);
          if (!isNaN(endDate) && now > endDate) {
            shouldRemove = true;
          }
        }

        if (shouldRemove) {
          slide.remove(); // Slide'ı DOM'dan sil
          indexesToRemove.push(index);
        }
      });

      // Pagination butonlarını da silmemiz lazım
      // Ters döngü ile siliyoruz ki indexler kaymasın
      for (let i = indexesToRemove.length - 1; i >= 0; i--) {
        const indexToRemove = indexesToRemove[i];
        if (allPageBtns[indexToRemove]) {
          allPageBtns[indexToRemove].remove();
        }
      }

      // Kalan pagination butonlarının data-index attribute'larını güncelle
      // (0, 1, 2, 3... şeklinde sıfırdan başlayarak yeniden numaralandır)
      const remainingPageBtns = this.querySelectorAll('.page-btn');
      remainingPageBtns.forEach((btn, newIndex) => {
        btn.setAttribute('data-index', newIndex);
        
        // Screen reader textini güncelle (Slide 1 of 3 gibi)
        const visuallyHiddenSpan = btn.querySelector('.visually-hidden');
        if (visuallyHiddenSpan) {
           // Basitçe texti güncelliyoruz, dil desteği için hardcoded kaçındık ama yapıya sadık kaldık
           // Orijinal text yapısını korumaya çalışıyoruz.
           visuallyHiddenSpan.innerHTML = visuallyHiddenSpan.innerHTML.replace(/\d+/g, (match) => {
               // Bu basit regex mevcut sayıları bulur. 
               // İlk sayı index+1, ikinci sayı total length.
               // Ancak çok dilli yapılarda risklidir. 
               // En güvenlisi sadece data-index'i güncellemek, CSS ile görseli zaten hallediyoruz.
               return match; 
           });
        }
      });
    }

    initAutoPlay() {
      this.autoplayEnabled = true;
      this.autoplaySpeed = this.dataset.speed * 1000;
      this.addEventListener('mouseover', this.pauseAutoplay.bind(this));
      this.addEventListener('mouseleave', this.resumeAutoplay.bind(this));
      this.slideshow.addEventListener('focusin', this.pauseAutoplay.bind(this));
      this.slideshow.addEventListener('focusout', this.resumeAutoplay.bind(this));

      this.addObserver();
      this.startAutoplay();
    }

    handleNavClick(evt) {
      if (evt.target.matches('.autoplay-btn')) {
        this.togglePlayState(evt);
        return;
      }

      if (evt.target.name === 'next') {
        this.showNextSlide();
      } else if (evt.target.name === 'prev') {
        this.showPrevSlide();
      }
    }

    handlePaginationClick(evt) {
      const btn = evt.target.closest('.page-btn'); // closest eklendi, svg tıklamaları için
      if (!btn) return;
      
      this.autoplayTimeLeft = this.autoplaySpeed;
      this.setActiveSlide(Number(btn.dataset.index));
    }

    handleWheel(evt) {
      if (evt.deltaX !== 0) evt.preventDefault();
      const isHorizontal = Math.abs(evt.deltaX) > Math.abs(evt.deltaY);
      const isHorizontalSignificant = Math.abs(evt.deltaX) > this.wheelSensitivity;

      if (isHorizontal && isHorizontalSignificant) {
        evt.deltaX > 0 ? this.showNextSlide() : this.showPrevSlide();
      }
    }

    handleKeyDown(evt) {
      if (evt.key === 'ArrowLeft' || evt.key === 'ArrowRight') {
        evt.preventDefault();
        if (evt.key === 'ArrowRight') {
          this.showNextSlide();
        }
        if (evt.key === 'ArrowLeft') {
          this.showPrevSlide();
        }
      }
    }

    handleTouchStart(evt) {
      this.touchStart = evt.changedTouches[0].screenX;
    }

    handleTouchMove(evt) {
      const touchEnd = evt.changedTouches[0].screenX;
      if (touchEnd < this.touchStart - this.swipeThreshold) {
        this.rtl ? this.showPrevSlide() : this.showNextSlide();
      }

      if (touchEnd > this.touchStart + this.swipeThreshold) {
        this.rtl ? this.showNextSlide() : this.showPrevSlide();
      }
    }

    static handleTransitionend(evt) {
      if (!evt.target.matches('.has-motion')) return;
      evt.target.classList.remove('transition-out');
    }

    showNextSlide() {
      let index = this.currentIndex + 1;
      if (index === this.slides.length) index = 0;
      this.setActiveSlide(index, 'next');
    }

    showPrevSlide() {
      let index = this.currentIndex - 1;
      if (index < 0) index = this.slides.length - 1;
      this.setActiveSlide(index, 'prev');
    }

    setActiveSlide(slideIndex, slideDirection) {
      if (slideIndex === this.currentIndex) return;
      clearTimeout(this.setActiveSlideTimeoutId);
      clearTimeout(this.autoplayTimer);

      let dir = slideDirection || (slideIndex < this.currentIndex ? 'prev' : 'next');
      if (this.rtl) dir = dir === 'next' ? 'prev' : 'next';
      this.dataset.direction = dir;

      if(this.slides[this.currentIndex]) {
        this.slides[this.currentIndex].classList.add('transition-out');
      }
      
      this.setActiveSlideTimeoutId = setTimeout(() => {
        if(this.slides[slideIndex]) {
            this.slideshow.scrollTo({ left: this.slides[slideIndex].offsetLeft, behavior: 'auto' });
            this.slides[slideIndex].classList.add('is-active');
            
            if(this.slides[this.currentIndex]) {
                this.slides[this.currentIndex].classList.remove('is-active', 'transition-out');
                const transitionedEl = this.slides[this.currentIndex].querySelector('.has-motion');
                if (transitionedEl) transitionedEl.classList.add('transition-out');
            }

            if (this.autoplayEnabled) this.autoplayStartTime = Date.now();

            if (this.counterCurrent) this.counterCurrent.textContent = slideIndex + 1;

            this.currentIndex = slideIndex;
            this.setSlideVisibility();
            this.updatePagination();

            if (this.autoplayEnabled && !this.autoplayPaused) {
            this.autoplayTimeLeft = this.autoplaySpeed;
            this.autoplayTimer = setTimeout(this.showNextSlide.bind(this), this.autoplaySpeed);
            }
        }
      }, 200);
    }

    updatePagination() {
      if (!this.pagination) return;
      this.pageBtns.forEach((el, index) => {
        if (index === this.currentIndex) {
          el.setAttribute('aria-current', 'true');
        } else {
          el.removeAttribute('aria-current');
        }
      });
    }

    stopAutoplay() {
      this.setSlideshowState('paused');
      clearTimeout(this.autoplayTimer);
    }

    startAutoplay() {
      this.autoplayTimeLeft = null;
      this.autoplayStartTime = Date.now();
      clearTimeout(this.autoplayTimer);
      this.autoplayTimer = setTimeout(this.showNextSlide.bind(this), this.autoplaySpeed);
      this.setSlideshowState('running');
    }

    pauseAutoplay() {
      if (!this.autoplayEnabled || this.autoplayPaused) return;
      this.stopAutoplay();

      if (this.autoplayTimeLeft) {
        this.autoplayTimeLeft -= (Date.now() - this.resumedTime);
      } else {
        this.autoplayTimeLeft = this.autoplaySpeed - (Date.now() - this.autoplayStartTime);
      }
    }

    resumeAutoplay() {
      if (!this.autoplayEnabled || !this.autoplayPaused) return;
      this.resumedTime = Date.now();
      this.autoplayTimer = setTimeout(this.showNextSlide.bind(this), this.autoplayTimeLeft);

      this.setSlideshowState('running');
    }

    addObserver() {
      if ('IntersectionObserver' in window === false) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.resumeAutoplay();
          } else {
            this.pauseAutoplay();
          }
        });
      });
      observer.observe(this);
    }

    setSlideVisibility() {
      this.slides.forEach((el, index) => {
        const btns = el.querySelectorAll('a');

        if (index === this.currentIndex) {
          el.setAttribute('aria-hidden', 'false');
          el.removeAttribute('tabindex');

          btns.forEach((btn) => {
            btn.removeAttribute('tabindex');
          });
        } else {
          el.setAttribute('aria-hidden', 'true');
          el.setAttribute('tabindex', '-1');

          btns.forEach((btn) => {
            btn.setAttribute('tabindex', '-1');
          });
        }
      });
    }

    setSlideshowState(state) {
      this.style.setProperty('--play-state', state);
      this.slideshow.setAttribute('aria-live', state === 'running' ? 'off' : 'polite');
      this.autoplayPaused = state === 'paused';
    }

    togglePlayState(evt) {
      evt.target.classList.toggle('is-paused');
      this.autoplayEnabled = !this.autoplayEnabled;
      this.dataset.autoplay = this.autoplayEnabled ? 'true' : 'false';
      this.autoplayEnabled ? this.startAutoplay() : this.stopAutoplay();
    }
  }

  customElements.define('slide-show-scheduler', SlideShowScheduler);
}